import { camelCase } from 'lodash'

import { InfraAttack } from 'types/api/attacks/details/infra-attack'
import {
  AttackCommandConfiguration,
  AttackConfiguration,
  AttackConfigurationTargetType,
  AttackSamplingConfiguration,
  ContainerTargetingStrategy,
  HostTargetingStrategy,
  KubernetesTargetingStrategy,
  SnakeCaseAttackConfiguration,
  TargetingStrategy
} from 'types/api/attacks/details/targeting'
import { K8sAttack } from 'types/api/kubernetes/attacks'
import { ScheduledAttack } from 'types/api/schedules/active'
import { cleanObjKeysAndValues } from 'utils/obj'

export function isK8sAttack(
  attack: InfraAttack | K8sAttack | ScheduledAttack
): attack is K8sAttack {
  return attack?.hasOwnProperty('uid')
}

export function getAttackConfiguration(
  attack: InfraAttack | K8sAttack | ScheduledAttack
): AttackConfiguration {
  return isK8sAttack(attack)
    ? attack.attackConfiguration
    : cleanObjKeysAndValues<SnakeCaseAttackConfiguration, AttackConfiguration>(
        attack?.attack_configuration,
        {
          keyTransformers: [camelCase],
          recursive: true
        }
      )
}

export function getCommand(
  attackConfiguration: AttackConfiguration
): AttackCommandConfiguration {
  return attackConfiguration.command
}

export function getTargetingStrategy(
  attackConfiguration: AttackConfiguration,
  index = 0
): TargetingStrategy {
  return attackConfiguration.targets[index].targetingStrategy
}

export function getTargetType(
  attackConfiguration: AttackConfiguration
): AttackConfigurationTargetType {
  return getTargetingStrategy(attackConfiguration).type
}

export function isHostTargetType(
  targetingStrategy: TargetingStrategy
): targetingStrategy is HostTargetingStrategy {
  return targetingStrategy.type === 'Host'
}

export function isContainerTargetType(
  targetingStrategy: TargetingStrategy
): targetingStrategy is ContainerTargetingStrategy {
  return targetingStrategy.type === 'Container'
}

export function isK8sTargetType(
  targetingStrategy: TargetingStrategy
): targetingStrategy is KubernetesTargetingStrategy {
  return targetingStrategy.type === 'Kubernetes'
}

export function getSampling(
  attackConfiguration: AttackConfiguration
): AttackSamplingConfiguration {
  return attackConfiguration.sampling
}
